import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";


const state = {
	hasSend: false, // 是否已发送重置邮件
	currentMail: '' // 当前填写的邮箱
};

const getters = {

};

const actions = {
	// 发送重置邮件
	sendMail({commit}, values) {
		let api = API_MAP.USER_RESET_MAIL;
		let method = 'post';
		let payload = values;
		let successCb = () => {
			commit('setCurrentMail', values.mail || '');
			commit('setSendStatus', true);
		};
		let errorCb = () => {};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	}
};

const mutations = {
	// 设置已发送状态
	setSendStatus(state, status) {
		state.hasSend = status;
	},
	// 设置当前填写的邮箱
	setCurrentMail(state, mail) {
		state.currentMail = mail;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
